<template>
    <div class="editor">
        <div class="mb-2">
			<div v-if="error=='NAME'" class="alert alert-danger my-2" role="alert">
				{{ lang['course.name_prompt'] }}
			</div>
			<div v-if="error=='NAME_LENGTH'" class="alert alert-danger my-2" role="alert">
				{{ lang['course.name_length_prompt'] }}
			</div>
            <label for="assignment-name" class="section-heading">{{ lang['course.name'] }}</label>
            <input id="assignment-name" class="form-control" type="text" v-model="course.name" @keyup="resetError">
        </div>

		<div class="edit-row mt-3">
			<label for="flashcard">{{ lang['course.allow_learners'] }}</label>
			<label class="switch">
				<input type="checkbox" v-model="course.can_enroll">
				<span class="slider-switch round"></span>
			</label>
		</div>

		<label for="options" class="section-heading d-flex justify-content-between align-items-center mt-3" @click="collapsed = !collapsed">{{ lang['general.options'] }} <i class="expand-options far" :class="{'fa-chevron-down': collapsed, 'fa-chevron-up': !collapsed}"></i></label>
		<div :class="{'options-hidden': collapsed, 'options-visible': !collapsed}">
			<div class="prompt">{{ lang['course.generate_code_prompt'] }}</div>
			<input type="text" class="form-control" v-model="course.enroll_code">
			<button class="btn btn-block btn-primary btn-gradient mt-2 mb-3" type="button" @click="generateCode">{{ lang['course.generate_code'] }}</button>

		</div>

        <!-- <template v-if="course.id && students.length > 0">
            <label for="stats" class="mt-3">Course Statisticts</label>
            <div  class="new-problem mb-2" @click="showCourseStats">View course statisticts{{ lang['course.course_stats'] }} <i class="fa fa-fw fa-bar-chart"></i></div>
        </template> -->

        <div v-if="showStudents" class="d-flex justify-content-between">
            <label class="mt-3">{{ lang['general.learners'] }}</label>
        </div>
        <div v-if="studentsLoaded">
            <template v-if="students.length > 0">
                <div class="search-wrapper mb-1">
                    <i class="fal fa-search"></i>
                    <input id="student-search" type="search" class="form-control" :placeholder="lang['course.search_learners']" v-model="searchTerm">
                </div>
                <div class="problem-card" id="classCard">
                    <div class="problem-text">Learners Overall</div>
                    <div class="ml-auto my-auto flex-stiff">
                        <!--<i class="fal fa-file" @click="openModal(student)" style="margin-left: 10px;"></i>-->
                        <!--<i class="fa fa-fw fa-files-o mr-2" @click="openModal(student)"></i>-->
                        <i class="fal fa-spinner fa-spin stats-spinner ml-2 hidden"></i>
                        <i class="fal fa-download ml-2" @click="exportStats()" title="Download Learner Scores"></i>
                        <i class="fal fa-chart-bar stats-icon ml-2" @click="showCourseStats()" title="Show Course Statistics"></i>
                    </div>
                </div>
                <div v-for="(student, index) in filteredStudents" class="problem-card" v-bind:id="'studentCard'+student.user_id">
                    <div class="problem-text">{{ student.last_name }}, {{ student.first_name }}</div>
                    <div class="ml-auto my-auto flex-stiff">
                        <i class="fal fa-spinner fa-spin stats-spinner hidden"></i>
                        <i class="fal fa-file ml-2" @click="openModal(student)" style="margin-left: 10px;" title="Show Learner Summary"></i>
                        <i class="fal fa-chart-bar stats-icon ml-2" @click="showStudentStats(student)" title="Show Learner Statistics"></i>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="prompt">There are no learners currently enrolled in this course. Remember to select "{{ lang['course.allow_learners'] }}" to make this course available.</div>
            </template>
        </div>
        <div v-else-if="showStudents" class="mt-4 flex-r flex-center" style="font-size: 1.25em;">
            <div><i class="far fa-spinner fa-spin mr-2 blue"></i> {{ lang['general.loading'] }}</div>
        </div>
        <student-modal v-if="learnerModal" :learner="selectedLearner" @close="closeModal"></student-modal>

    </div>
</template>

<script>
export default {
    props: ['content', 'model'],
	data() {
		return {
			course: {},
			error: false,
            students: [],
            studentsLoaded: false,
            showStudents: false,
            selectedLearner: {},
			filteredStudents: [],
			searchTerm: "",
			collapsed: false,
            lang: lang,
            learnerModal: false,
		}
	},

	mounted() {
		if(Object.keys(this.content).length > 0) {
            this.course = this.content;
            if(this.course.id) {
                this.showStudents = true;
				this.getStudents(this.content);
				this.collapsed = true;
            }
        }
	},

	methods: {
		closeModal() {
            this.learnerModal = false;
        },

        openModal(learner) {
            this.selectedLearner = learner;
            this.selectedLearner.courseId = this.course.id;
            this.learnerModal = true;
        },

		generateCode() {
			var codeLen = Math.floor(Math.random() * 4) + 10;
            var validChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var code = "";
            for (var c = 0; c < codeLen; c++) {
				code += validChars.charAt(Math.floor(Math.random() * validChars.length));
            }
			this.course.enroll_code = code;
			this.$forceUpdate();
        },

		showStudentStats(student) {
			$(".nodeRect").attr("style", null);
			$(".link").attr("style", null);
			$("#detailsButtons").empty();
			$(".stats-icon.main-blue").removeClass("main-blue");
			if($("#studentCard"+student.user_id).hasClass("selected")){
                $(".problem-card.selected").removeClass("selected");
                return;
            }
			$(".problem-card.selected").removeClass("selected");
			$("#studentCard"+student.user_id).addClass("selected");
            $("#studentCard"+student.user_id+" .stats-icon").addClass("main-blue");
            $("#studentCard"+student.user_id+" .stats-spinner").removeClass("hidden");
			loadStudentStats(student.user_id, this.course.id);
		},

        exportStats() {
		    window.location.href = "/courses/export_csv/" + this.course.id;
		    //
            // $.get('/courses/export_csv/' + this.course.id,
            //     response => {})
            //     .catch((error) => {
            //         bus.$emit('popupError', error);
            //     });
        },

		showCourseStats() {
            $(".nodeRect").attr("style", null);
            $(".link").attr("style", null);
            $("#detailsButtons").empty();
            $(".stats-icon.main-blue").removeClass("main-blue");
            if($("#classCard").hasClass("selected")){
                $(".problem-card.selected").removeClass("selected");
                return;
            }
            $(".problem-card.selected").removeClass("selected");
            $("#classCard").addClass("selected");
            $("#classCard .stats-icon").addClass("main-blue");
            $("#classCard .stats-spinner").removeClass("hidden");
			loadClassStats(this.course.id);
		},

		getStudents(course) {
			this.icons = [
				{name: 'fa fa-fw fa-files-o', method: this.studentAssignments},
				{name: 'fa fa-fw fa-bar-chart', method: this.stats},
			]
			$.get('/students/' + this.course.id,
			response => {
				this.students = response;
				this.filteredStudents = response;
				this.studentsLoaded = true;
			})
            .catch((error) => {
                bus.$emit('popupError', error);
            });
		},

		resetError() {
			this.error = false;
		},

		save() {
			if(!this.course.name || this.course.name.trim().length == 0) {
				this.error = 'NAME';
			} else if (this.course.name.length > 60) {
				this.error = 'NAME_LENGTH';
			} else {
                if(this.course.can_enroll && this.course.can_enroll > 0) {
                    this.course.shared = 1;
                }
				var $this = this;
				$.post('/courses', {
					id: this.course.id || -1,
					name: this.course.name,
					model_id: this.course.model_id || this.model,
					can_enroll: this.course.can_enroll ? 1 : 0,
					enroll_code: this.course.enroll_code,
                    language: this.course.language || 'English',
                    shared: this.course.shared,
				}, response => {
					if(!response.error) {
						$this.$emit('close');
					}
				})
                .catch((error) => {
                    bus.$emit('popupError', error);
                });
			}
		},

	},

	watch: {
		searchTerm(val) {
			if(!val.trim().length > 0) {
				this.filteredStudents = this.students;
			} else {
				this.filteredStudents = this.students.filter(student => {
					let studentStr = student.last_name + ',' + student.first_name;
					return studentStr.toLowerCase().includes(val.trim().toLowerCase())
				});
			}
		}
	},

	created() {
		bus.$on('save', this.save);
	},

	beforeDestroy() {
		bus.$off('save', this.save);
		//TODO This needs to change when we get the non D3 drawn model
		$(".nodeRect").attr("style", null);
		$(".link").attr("style", null);
	}

}
</script>
